import { RoundingDirection, RoundingOption } from "definitions/exporter";

// Пресет при включении тумблера. direction='ceil' по умолчанию: продавцу
// безопаснее, чтобы итоговая цена никогда не уезжала ВНИЗ и не съедала маржу
// молча (nearest округлил бы вниз примерно на половине цен). Шаг — сотни
// (zeros=2): типичная розничная цена и совпадает со старым ROUNDING_PRICE.
export const FRESH_ROUNDING_OPTION: RoundingOption = {
  zeros: 2,
  direction: "ceil",
};

// Пресет для миграции старых задач с трансформером ROUNDING_PRICE — он
// эквивалентен {zeros:2, nearest}; сохраняем точное историческое поведение
// (в отличие от FRESH-пресета выше, который оптимизирует маржу нового юзера).
export const LEGACY_ROUNDING_OPTION: RoundingOption = {
  zeros: 2,
  direction: "nearest",
};

export const roundingStepRubles = (zeros: number): number => 10 ** zeros;

export const STEP_OPTIONS: { value: string; content: string; title: string }[] =
  [
    { value: "1", content: "Десятки", title: "1587 → 1590" },
    { value: "2", content: "Сотни", title: "1587 → 1600" },
    { value: "3", content: "Тысячи", title: "1587 → 2000" },
  ];

export const DIRECTION_OPTIONS: {
  value: RoundingDirection;
  content: string;
}[] = [
  { value: "ceil", content: "Вверх" },
  { value: "nearest", content: "До ближайшего" },
  { value: "floor", content: "Вниз" },
];
